export const mode = import.meta.env.VITE_NODE_ENV;

export const apiClientUrl = import.meta.env.VITE_API_CLIENT_URL;

export const agentVersion = import.meta.env.VITE_AGENT_VERSION;

export const domain = import.meta.env.VITE_DOMAIN;

export const isDevServer = import.meta.env.VITE_IS_DEV_SERVER;

export const datadogApplicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID || '';

export const datadogClientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '';

export const datadogService = import.meta.env.VITE_DATADOG_SERVICE || '';

export const staticUrl = import.meta.env.VITE_STATIC_URL || '';
